export default "__VITE_ASSET__7be3b9cb__"